import { render, staticRenderFns } from "./ShowLxrInfo.vue?vue&type=template&id=7161ce76&scoped=true&"
import script from "./ShowLxrInfo.vue?vue&type=script&lang=js&"
export * from "./ShowLxrInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7161ce76",
  null
  
)

export default component.exports